import styled from '@emotion/styled';

interface StyledTbmAttandanceProps {
  scrollY?: number;
}

export const StyledTbmAttandance = styled.div<StyledTbmAttandanceProps>`
  .attandance-wrapper {
    padding: 24px;
    height: ${({ scrollY }) => (scrollY ? `${scrollY}px` : '100%')};

    &-top {
    }

    &-body {
      margin-top: 24px;
    }
  }
`;

export const StyledAttendanceHistoryBox = styled.div`
  width: 100%;
  height: 100%;
  background: var(--color-off-white);
  padding: 5px 0px;
  display: flex;
  align-items: center;
  justify-content: center;

  &.white {
    background: var(--color-white) !important;
  }
`;
